export function toProperCase(value: string): string {
  return value
    .replace(/_/g, ' ')
    .replace(/\b\w+/g, (word) => word[0].toUpperCase() + word.slice(1));
}
